import Vue from 'vue'
import Router from 'vue-router'
import MaintainFund from '@/views/maintainFund/index.vue'
import Page404 from '@/layout/404'
import Page500 from '@/layout/500'
import Real from '@/views/real/index.vue'
import billObtainRouter from "@/router/billObtain"
Vue.use(Router)

import houseResourceRouter from './houseResource'
import maintainFundRouter from './maintainFund'
import publicRouter from "./public";
import personalRouter from "./personal";
import onlineDepositRouter from "./onlineDeposit";


/**
 * hasTab: false                  设置为true，则显示底部标签栏
 * activeTab: 0                   设置当前活动标签栏目
 */

export const constantRoutes = [
	{
		path: '/',
		name: 'MaintainFund',
		component: MaintainFund
	},
	{
		path: '*',
		name: 'Page404',
		component: Page404
	},
	{
		path: '/500',
		name: 'Page500',
		component: Page500
	},
	{
		path: '/real',
		name: 'Real',
		component: Real
	},
	billObtainRouter
].concat(houseResourceRouter).concat(maintainFundRouter).concat(publicRouter).concat(personalRouter).concat(onlineDepositRouter)

const createRouter = () => new Router({
	// mode: 'history', // require service support
	scrollBehavior: () => ({y: 0}),
	routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

export default router
